import { render, staticRenderFns } from "./EventRecordDetail.vue?vue&type=template&id=34a713a0&scoped=true"
import script from "./EventRecordDetail.vue?vue&type=script&lang=js"
export * from "./EventRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./EventRecordDetail.vue?vue&type=style&index=0&id=34a713a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a713a0",
  null
  
)

export default component.exports